/**
 * APPENS ENDA KLIENT.
 *
 * Skapa aldrig en egen Klartidklient i en skärm: den skulle få ett eget valv
 * och ett eget utloggningsbesked, och två klienter som förnyar samma licens
 * skriver över varandra.
 *
 * UTLOGGNINGEN GÅR TVÅ VÄGAR, med flit.
 *   1. Klienten RENSAR VALVET när servern sagt UNAUTHENTICATED eller
 *      LICENSE_EXPIRED. Valvet är en extern lagring, så varje komponent som
 *      lyssnar på det ritas om — det behövs ingen callback för att appen ska
 *      hamna på inloggningsskärmen.
 *   2. SKÄLET sparas här. Utan det skulle en montör vars 30-dagarsbevis gått ut
 *      möta en tom inloggningsruta utan förklaring, och beslut 12:s hela löfte
 *      ("ingenting är förlorat, utkorgen ligger kvar") skulle vara osynligt.
 */

import { Klartidklient } from './klient';
import type { Klartidfel } from './fel';

let sistaUtloggningen: Klartidfel | null = null;

export const klienten = new Klartidklient({
  vidUtloggning: (fel) => {
    sistaUtloggningen = fel;
  },
});

/** Varför användaren blev utloggad, eller null om han loggade ut själv. */
export const senasteUtloggningsfel = (): Klartidfel | null => sistaUtloggningen;

/** Ropas när skälet visats, så att det inte dyker upp igen vid nästa inloggning. */
export const glomUtloggningsfel = (): void => {
  sistaUtloggningen = null;
};
